/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-30 13:39:14
 * @FilePath: \frontend\src\utils\message.js
 */
import { i18n } from '@/Lang/index';

export const errorMsg = {
  e_cannot_empty: i18n.global.t('errorMsg.e_cannot_empty'),
  e_fm_id_empty: i18n.global.t('errorMsg.e_fm_id_empty'),
  e_illegal_file: i18n.global.t('errorMsg.e_illegal_file'),

  e_cond_id_empty: i18n.global.t('errorMsg.e_cond_id_empty'),
  e_cond_enable_empty: i18n.global.t('errorMsg.e_cond_enable_empty'),
  e_cond_enable_invalid: i18n.global.t('errorMsg.e_cond_enable_invalid'),

  e_grp_id_empty: i18n.global.t('errorMsg.e_grp_id_empty'),

  e_cond_count_upperlimit: i18n.global.t('errorMsg.e_cond_count_upperlimit'),
  e_cond_name_empty: i18n.global.t('errorMsg.e_cond_name_empty'),
  e_cond_name_length: i18n.global.t('errorMsg.e_cond_name_length'),
  e_cond_name_exist: i18n.global.t('errorMsg.e_cond_name_exist'),
  e_alert_email_content_length: i18n.global.t('errorMsg.e_alert_email_content_length'),

  e_cat_id_empty: i18n.global.t('errorMsg.e_cat_id_empty'),
  e_cat_name_empty: i18n.global.t('errorMsg.e_cat_name_empty'),
  e_group_name_empty: i18n.global.t('errorMsg.e_group_name_empty'),
  e_cat_name_exist: i18n.global.t('errorMsg.e_cat_name_exist'),
  e_cat_group: i18n.global.t('errorMsg.e_cat_group'),

  e_enable_no_formulas_cond: i18n.global.t('errorMsg.e_enable_no_formulas_cond'),
  e_enable_cond_fm_dev_config_changed: i18n.global.t('errorMsg.e_enable_cond_fm_dev_config_changed'),
  e_fm_order_empty: i18n.global.t('errorMsg.e_fm_order_empty'),
  e_formula_type_empty: i18n.global.t('errorMsg.e_formula_type_empty'),
  e_formula_type_exist: i18n.global.t('errorMsg.e_formula_type_exist'),
  e_formula_type_invalid: i18n.global.t('errorMsg.e_formula_type_invalid'),
  e_dev_data_type_empty: i18n.global.t('errorMsg.e_dev_data_type_empty'),
  e_dev_data_type_invalid: i18n.global.t('errorMsg.e_dev_data_type_invalid'),
  e_formula_val1_empty: i18n.global.t('errorMsg.e_formula_val1_empty'),
  e_formula_val2_empty: i18n.global.t('errorMsg.e_formula_val2_empty'),
  e_cond_formula_count_upperlimit: i18n.global.t('errorMsg.e_cond_formula_count_upperlimit'),

  e_alert_need_times_empty: i18n.global.t('errorMsg.e_alert_need_times_empty'),
  e_alert_need_times_int: i18n.global.t('errorMsg.e_alert_need_times_int'),
  e_alert_need_times_invalid: i18n.global.t('errorMsg.e_alert_need_times_invalid'),

  e_alert_in_minutes_empty: i18n.global.t('errorMsg.e_alert_in_minutes_empty'),
  e_alert_in_minutes_int: i18n.global.t('errorMsg.e_alert_in_minutes_int'),

  e_alert_web_notice_empty: i18n.global.t('errorMsg.e_alert_web_notice_empty'),

  e_alert_email_empty: i18n.global.t('errorMsg.e_alert_email_empty'),
  e_alert_email_scope: i18n.global.t('errorMsg.e_alert_email_scope'),

  e_alert_web_notice_email_empty: i18n.global.t('errorMsg.e_alert_web_notice_email_empty'),

  e_reached_snooze_minutes_empty: i18n.global.t('errorMsg.e_reached_snooze_minutes_empty'),
  e_reached_snooze_minutes_int: i18n.global.t('errorMsg.e_reached_snooze_minutes_int'),

  e_alert_type_empty: i18n.global.t('errorMsg.e_alert_type_empty'),
  e_alert_type_scope: i18n.global.t('errorMsg.e_alert_type_scope'),

  e_role_id_empty: i18n.global.t('errorMsg.e_role_id_empty'),
  e_role_id_scope: i18n.global.t('errorMsg.e_role_id_scope'),

  e_user_name_exist: i18n.global.t('errorMsg.e_user_name_exist'),
  e_old_password_error: i18n.global.t('errorMsg.e_old_password_error'),
  e_same_password_error: i18n.global.t('errorMsg.e_same_password_error'),
  e_user_add_admin: i18n.global.t('errorMsg.e_user_add_admin'),

  e_password_empty: i18n.global.t('errorMsg.e_password_empty'),
  e_password_length: i18n.global.t('errorMsg.e_password_length'),
  e_user_name_empty: i18n.global.t('errorMsg.e_user_name_empty'),
  e_user_id_empty: i18n.global.t('errorMsg.e_user_id_empty'),
  e_user_name_length: i18n.global.t('errorMsg.e_user_name_length'),

  e_mapX_empty: i18n.global.t('errorMsg.e_mapX_empty'),
  e_mapY_empty: i18n.global.t('errorMsg.e_mapY_empty'),
  e_devKey_empty: i18n.global.t('errorMsg.e_devKey_empty'),
  e_edit_dev_empty: i18n.global.t('errorMsg.e_edit_dev_empty'),
  e_devKey_empty_array: i18n.global.t('errorMsg.e_devKey_empty_array'),
  e_db_id_empty: i18n.global.t('errorMsg.e_db_id_empty'),
  e_w_id_empty: i18n.global.t('errorMsg.e_w_id_empty'),
  e_note_empty: i18n.global.t('errorMsg.e_note_empty'),
  e_note_upperlimit: i18n.global.t('errorMsg.e_note_upperlimit'),
  e_cfg_id_empty: i18n.global.t('errorMsg.e_cfg_id_empty'),
  e_cfg_key_empty: i18n.global.t('errorMsg.e_cfg_key_empty'),
  e_cfg_type_empty: i18n.global.t('errorMsg.e_cfg_type_empty'),
  e_cfg_json_empty: i18n.global.t('errorMsg.e_cfg_json_empty'),
  e_cfg_value_empty: i18n.global.t('errorMsg.e_cfg_value_empty'),
  e_cfg_json_invalid: i18n.global.t('errorMsg.e_cfg_json_invalid'),

  e_mail_cfg_empty: i18n.global.t('errorMsg.e_mail_cfg_empty'),

  e_mail_smtp_empty: i18n.global.t('errorMsg.e_mail_smtp_empty'),
  e_mail_smtp_invalid: i18n.global.t('errorMsg.e_mail_smtp_invalid'),

  e_mail_from_empty: i18n.global.t('errorMsg.e_mail_from_empty'),
  e_mail_from_invalid: i18n.global.t('errorMsg.e_mail_from_invalid'),
  e_mail_to_empty: i18n.global.t('errorMsg.e_mail_to_empty'),
  e_mail_to_exist: i18n.global.t('errorMsg.e_mail_to_exist'),
  e_mail_to_invalid: i18n.global.t('errorMsg.e_mail_to_invalid'),
  e_mail_to_upperlimit: i18n.global.t('errorMsg.e_mail_to_upperlimit'),

  e_mail_pass_empty: i18n.global.t('errorMsg.e_mail_pass_empty'),
  e_exist_conflict_dev: i18n.global.t('errorMsg.e_exist_conflict_dev'),

  e_user_not_exist: i18n.global.t('errorMsg.e_user_not_exist'),
  e_password_error: i18n.global.t('errorMsg.e_password_error'),

  e_rpc_timeout: i18n.global.t('errorMsg.e_rpc_timeout'),
  e_unknow_err: i18n.global.t('errorMsg.e_unknow_err'),
  e_invalid_parameter: i18n.global.t('errorMsg.e_invalid_parameter'),
  e_no_file_upload: i18n.global.t('errorMsg.e_no_file_upload'),
  e_file_upload_failed: i18n.global.t('errorMsg.e_file_upload_failed'),
  e_upgrade_file_verify_failed: i18n.global.t('errorMsg.e_upgrade_file_verify_failed'),
  e_upgrade_failed: i18n.global.t('errorMsg.e_upgrade_failed'),
  e_time_value_error: i18n.global.t('errorMsg.e_time_value_error'),
  e_timezone_value_error: i18n.global.t('errorMsg.e_timezone_value_error'),
  e_test_mail_failed: i18n.global.t('errorMsg.e_test_mail_failed'),

  e_subg_timeout: i18n.global.t('errorMsg.e_subg_timeout'),
  e_subg_nwk_has_open: i18n.global.t('errorMsg.e_subg_nwk_has_open'),

  e_unknown_firmware_format: i18n.global.t('errorMsg.e_unknown_firmware_format'),
  e_firmware_version_too_old: i18n.global.t('errorMsg.e_firmware_version_too_old'),
  e_firmware_dependencies_not_satisfied: i18n.global.t('errorMsg.e_firmware_dependencies_not_satisfied'),
  e_no_enough_free_space: i18n.global.t('errorMsg.e_no_enough_free_space'),
  e_wrong_firmware_signature: i18n.global.t('errorMsg.e_wrong_firmware_signature'),
  e_wlist_item_exist: i18n.global.t('errorMsg.e_wlist_item_exist'),
  e_no_wlist_item: i18n.global.t('errorMsg.e_no_wlist_item'),

  e_dev_name_exist: i18n.global.t('errorMsg.e_dev_name_exist'),
  e_pageNo_empty_invalid: i18n.global.t('errorMsg.e_pageNo_empty_invalid'),
  e_pageRows_empty_invalid: i18n.global.t('errorMsg.e_pageRows_empty_invalid'),
  e_empty_dev_name: i18n.global.t('errorMsg.e_empty_dev_name'),
  e_cfg_key_exist: i18n.global.t('errorMsg.e_cfg_key_exist'),
  e_incomplete_param: i18n.global.t('errorMsg.e_incomplete_param'),

  e_export_backup_failed: i18n.global.t('errorMsg.e_export_backup_failed'),
  e_verify_backup_failed: i18n.global.t('errorMsg.e_verify_backup_failed'),
  e_apply_backup_failed: i18n.global.t('errorMsg.e_apply_backup_failed'),
  e_dev_ct_pulse_formula: i18n.global.t('errorMsg.e_dev_ct_pulse_formula'),
  e_Formula_name_exist: i18n.global.t('errorMsg.e_Formula_name_exist'),
  e_empty_replicate_dev_config: i18n.global.t('errorMsg.e_empty_replicate_dev_config'),

  W_is_exclusive: i18n.global.t('errorMsg.W_is_exclusive'),

  Test_send_mail_failed: i18n.global.t('errorMsg.Test_send_mail_failed'),
  E_seneor_data: i18n.global.t('errorMsg.E_seneor_data'),
  E_category_name: i18n.global.t('errorMsg.E_category_name'),
  E_data_not_selected: i18n.global.t('errorMsg.E_data_not_selected'),
  E_upload_file_too_large: i18n.global.t('errorMsg.E_upload_file_too_large'),
  Test_ntp_failed: i18n.global.t('errorMsg.Test_ntp_failed'),
  Set_ntp_failed: i18n.global.t('errorMsg.Set_ntp_failed'),
  Login_failed: i18n.global.t('errorMsg.Login_failed'),
  Logout_failed: i18n.global.t('errorMsg.Logout_failed'),
  Connect_wlan_failed: i18n.global.t('errorMsg.Connect_wlan_failed'),
  Error_cat_name: i18n.global.t('errorMsg.Error_cat_name'),
  Empty_Subg_IP_or_Port: i18n.global.t('errorMsg.Empty_Subg_IP_or_Port'),

  Error_map_image_too_large: i18n.global.t('errorMsg.Error_map_image_too_large'),
  Error_map_image_size_too_large: i18n.global.t('errorMsg.Error_map_image_size_too_large'),
  Error_file_too_large: i18n.global.t('errorMsg.Error_file_too_large'),
  Error_not_image: i18n.global.t('errorMsg.Error_not_image'),
  No_formula_choose: i18n.global.t('errorMsg.no_formula_choose'),
  E_Merge_File_Failed: i18n.global.t('errorMsg.E_Merge_File_Failed'),

  E_Build_Timeout: i18n.global.t('errorMsg.E_Build_Timeout'),

  Upload_file_failed: i18n.global.t('errorMsg.Upload_file_failed'),

  Formula_Choosed: i18n.global.t('errorMsg.Formula_Choosed'),

  e_error_param: i18n.global.t('errorMsg.e_error_param'),

  e_no_node_list_file: i18n.global.t('errorMsg.e_no_node_list_file'),
  e_no_alert_conf_file: i18n.global.t('errorMsg.e_no_alert_conf_file'),

  e_path_not_exist: i18n.global.t('errorMsg.e_path_not_exist'),
  e_file_not_exist: i18n.global.t('errorMsg.e_file_not_exist'),
  e_empty_devType: i18n.global.t('errorMsg.e_empty_devType'),
  e_empty_fileList: i18n.global.t('errorMsg.e_empty_fileList'),

  e_req_timeout: i18n.global.t('errorMsg.e_req_timeout'),
  e_empty_table_columns: i18n.global.t('errorMsg.e_empty_table_columns'),
  e_empty_list: i18n.global.t('errorMsg.e_empty_list'),
  e_empty_fileMd5: i18n.global.t('errorMsg.e_empty_fileMd5'),

  No_URLParameters: i18n.global.t('errorMsg.No_URLParameters'),
  e_nonexistent_tenant: i18n.global.t('errorMsg.e_nonexistent_tenant'),
  No_viewable_pages: i18n.global.t('errorMsg.No_viewable_pages'),
  e_request_failed_err: i18n.global.t('errorMsg.e_request_failed_err'),
  e_mqtt_failed_err: i18n.global.t('errorMsg.e_mqtt_failed_err'),
  e_change_nwkconfig_failed: i18n.global.t('errorMsg.e_change_nwkconfig_failed'),
  e_empty_area_name: i18n.global.t('errorMsg.e_empty_area_name'),
  e_register_gw_failed: i18n.global.t('errorMsg.e_register_gw_failed'),
  e_not_allowed_error: i18n.global.t('errorMsg.e_not_allowed_error'),
  e_not_found_error: i18n.global.t('errorMsg.e_not_found_error'),
  e_not_readable_error: i18n.global.t('errorMsg.e_not_readable_error'),
  e_overconstrained_error: i18n.global.t('errorMsg.e_overconstrained_error'),
  e_not_supported_error: i18n.global.t('errorMsg.e_not_supported_error'),
  e_security_error: i18n.global.t('errorMsg.e_security_error'),
  e_type_error: i18n.global.t('errorMsg.e_type_error'),
  e_abort_error: i18n.global.t('errorMsg.e_abort_error'),
  e_serial_no_error: i18n.global.t('errorMsg.e_serial_no_error'),
  e_register_service_failed: i18n.global.t('errorMsg.e_register_service_failed'),
  e_register_contract_failed: i18n.global.t('errorMsg.e_register_contract_failed'),
  e_signed_url_failed: i18n.global.t('errorMsg.e_signed_url_failed'),
  e_register_subscription_events_failed: i18n.global.t('errorMsg.e_register_subscription_events_failed'),
  e_start_services_failed: i18n.global.t('errorMsg.e_start_services_failed'),
  e_cancel_services_failed: i18n.global.t('errorMsg.e_cancel_services_failed'),
};

export const warningMsg = {
  Unknown_Status: i18n.global.t('warningMsg.Unknown_Status'),
  Gateway_Occupied: i18n.global.t('warningMsg.Gateway_Occupied'),
  Another_user_login: i18n.global.t('warningMsg.Another_user_login'),
  Admin_login: i18n.global.t('warningMsg.Admin_login'),
  DevList_Change: i18n.global.t('warningMsg.DevList_Change'),
  Login_timeout: i18n.global.t('warningMsg.Login_timeout'),
  User_role_change: i18n.global.t('warningMsg.User_role_change'),
  No_data_change: i18n.global.t('warningMsg.No_data_change'),
  Another_user_has_confrimed: i18n.global.t('warningMsg.Another_user_has_confrimed'),

  Map_image_not_exist: i18n.global.t('warningMsg.Map_image_not_exist'),
  Edit_two_sub_gateway_config_warning: i18n.global.t('warningMsg.Edit_two_sub_gateway_config_warning'),
  Edit_two_formula_warning: i18n.global.t('warningMsg.Edit_two_formula_warning'),
  Max_User_Num: i18n.global.t('warningMsg.Max_user_num'),
  Only_One_General_User: i18n.global.t('warningMsg.Only_One_General_User'),

  Already_Login: i18n.global.t('warningMsg.Already_Login'),
  Admin_Already_Login: i18n.global.t('warningMsg.Admin_Already_Login'),
  Same_Nwk_Config: i18n.global.t('warningMsg.Same_Nwk_Config'),
  Duplicated_DevId: i18n.global.t('warningMsg.Duplicated_DevId'),
  Idle_Timeout: i18n.global.t('warningMsg.Idle_Timeout'),
  Duplicated_Area_Name: i18n.global.t('warningMsg.Duplicated_Area_Name'),
  Area_Deleted: i18n.global.t('warningMsg.Area_Deleted'),
  MQTT_Disconnected: i18n.global.t('warningMsg.MQTT_Disconnected'),
  MQTT_Failed_Recconection: i18n.global.t('warningMsg.MQTT_Failed_Recconection'),
  Max_gw_num: i18n.global.t('warningMsg.Max_gw_num'),
  Max_dev_num: i18n.global.t('warningMsg.Max_dev_num'),
  Not_normal_gw_status: i18n.global.t('warningMsg.Not_normal_gw_status'),
  GW_status_change: i18n.global.t('warningMsg.GW_status_change'),
  No_Admin_User: i18n.global.t('warningMsg.No_Admin_User'),
  User_Deleted: i18n.global.t('warningMsg.User_Deleted'),
  Admin_role_changed: i18n.global.t('warningMsg.Admin_role_changed'),
  Duplicated_User_Name: i18n.global.t('warningMsg.Duplicated_User_Name'),
  Thing_name_not_exist: i18n.global.t('warningMsg.Thing_name_not_exist'),
  Duplicated_Gateway_Id: i18n.global.t('warningMsg.Duplicated_Gateway_Id'),
  SensorData_Encryption_Mismatch: i18n.global.t('warningMsg.SensorData_Encryption_Mismatch'),
};

export const successMsg = {
  Save_Map_Font_Size_success: i18n.global.t('successMsg.Save_Map_Font_Size_success'),
  Online: i18n.global.t('successMsg.Online'),
  Triggered: i18n.global.t('successMsg.Triggered'),
  Dev_add: i18n.global.t('successMsg.Dev_add'),
  Dev_setting_updated: i18n.global.t('successMsg.Dev_setting_updated'),
  Change_pass_success: i18n.global.t('successMsg.Change_pass_success'),
  Save_mail_cfg_success: i18n.global.t('successMsg.Save_mail_cfg_success'),
  Test_send_mail_success: i18n.global.t('successMsg.Test_send_mail_success'),
  Delete_mail_cfg_success: i18n.global.t('successMsg.Delete_mail_cfg_success'),
  Set_nwk_cfg_success: i18n.global.t('successMsg.Set_nwk_cfg_success'),
  Set_common_cfg_success: i18n.global.t('successMsg.Set_common_cfg_success'),
  Set_vb_cfg_success: i18n.global.t('successMsg.Set_vb_cfg_success'),
  Add_category_success: i18n.global.t('successMsg.Add_category_success'),
  Del_category_success: i18n.global.t('successMsg.Del_category_success'),
  Update_category_success: i18n.global.t('successMsg.Update_category_success'),
  Update_dev_category_success: i18n.global.t('successMsg.Update_dev_category_success'),

  Update_dev_config_success: i18n.global.t('successMsg.Update_dev_config_success'),
  Update_success: i18n.global.t('successMsg.Update_success'),
  Del_success: i18n.global.t('successMsg.Del_success'),
  Upload_upgrade_file_success: i18n.global.t('successMsg.Upload_upgrade_file_success'),
  Start_ap_success: i18n.global.t('successMsg.Start_ap_success'),
  Stop_ap_success: i18n.global.t('successMsg.Stop_ap_success'),
  Set_sys_nwk_success: i18n.global.t('successMsg.Set_sys_nwk_success'),
  Set_ap_wlan_success: i18n.global.t('successMsg.Set_ap_wlan_success'),

  Set_ap_ip_success: i18n.global.t('successMsg.Set_ap_ip_success'),
  Add_white_list_success: i18n.global.t('successMsg.Add_white_list_success'),
  Del_white_list_success: i18n.global.t('successMsg.Del_white_list_success'),
  Start_white_list_success: i18n.global.t('successMsg.Start_white_list_success'),
  Stop_white_list_success: i18n.global.t('successMsg.Stop_white_list_success'),
  Set_sys_time_success: i18n.global.t('successMsg.Set_sys_time_success'),
  Set_sys_timezone_success: i18n.global.t('successMsg.Set_sys_timezone_success'),
  Test_ntp_success: i18n.global.t('successMsg.Test_ntp_success'),
  Set_ntp_success: i18n.global.t('successMsg.Set_ntp_success'),
  Start_ntp_success: i18n.global.t('successMsg.Start_ntp_success'),
  Stop_ntp_success: i18n.global.t('successMsg.Stop_ntp_success'),
  Save_table_setting_success: i18n.global.t('successMsg.Save_table_setting_success'),
  Save_device_list_cfg_success: i18n.global.t('successMsg.Save_device_list_cfg_success'),

  Start_subghz_mode_success: i18n.global.t('successMsg.Start_subghz_mode_success'),
  Stop_subghz_mode_success: i18n.global.t('successMsg.Stop_subghz_mode_success'),
  Confirm_alert_success: i18n.global.t('successMsg.Confirm_alert_success'),
  Another_user_confrim: i18n.global.t('successMsg.Another_user_confrim'),
  Save_wlan_option_success: i18n.global.t('successMsg.Save_wlan_option_success'),
  Save_station_config_success: i18n.global.t('successMsg.Save_station_config_success'),
  Connect_wlan_success: i18n.global.t('successMsg.Connect_wlan_success'),
  Save_syscfg_success: i18n.global.t('successMsg.Save_syscfg_success'),
  Update_mapXY_success: i18n.global.t('successMsg.Update_mapXY_success'),
  Upload_map_success: i18n.global.t('successMsg.Upload_map_success'),
  Delete_syscfg_success: i18n.global.t('successMsg.Delete_syscfg_success'),
  Update_map_device_success: i18n.global.t('successMsg.Update_map_device_success'),
  AddReplicateDevSuccess: i18n.global.t('successMsg.AddReplicateDevSuccess'),

  Enable_condition_success: i18n.global.t('successMsg.Enable_condition_success'),
  Disable_condition_success: i18n.global.t('successMsg.Disable_condition_success'),
  Delete_condition_success: i18n.global.t('successMsg.Delete_condition_success'),
  Add_condition_success: i18n.global.t('successMsg.Add_condition_success'),
  Update_condition_success: i18n.global.t('successMsg.Update_condition_success'),

  Update_user_success: i18n.global.t('successMsg.Update_user_success'),
  Add_user_success: i18n.global.t('successMsg.Add_user_success'),
  Delete_user_success: i18n.global.t('successMsg.Delete_user_success'),
  Reset_password_success: i18n.global.t('successMsg.Reset_password_success'),

  Update_formula_success: i18n.global.t('successMsg.Update_formula_success'),
  Delete_formula_success: i18n.global.t('successMsg.Delete_formula_success'),
  Add_formula_success: i18n.global.t('successMsg.Add_formula_success'),
  Update_device_formula_success: i18n.global.t('successMsg.Update_device_formula_success'),
  Delete_device_formula_success: i18n.global.t('successMsg.Delete_device_formula_success'),

  Save_sub_gateway_config_success: i18n.global.t('successMsg.Save_sub_gateway_config_success'),
  Save_notification_success: i18n.global.t('successMsg.Save_notification_success'),
  Save_success: i18n.global.t('successMsg.Save_success'),
  Delete_sub_gateway_config_success: i18n.global.t('successMsg.Delete_sub_gateway_config_success'),

  Upload_setting_file_success: i18n.global.t('successMsg.Upload_setting_file_success'),
  Upload_app_setting_file_success: i18n.global.t('successMsg.Upload_app_setting_file_success'),
  Upload_unit_value_success: i18n.global.t('successMsg.Upload_unit_value_success'),
  Upload_dummy_node_list_file_success: i18n.global.t('successMsg.Upload_dummy_node_list_file_success'),

  Save_gw_name_success: i18n.global.t('successMsg.Save_gw_name_success'),
  Save_chart_success: i18n.global.t('successMsg.Save_chart_success'),

  Copy_contact_success: i18n.global.t('successMsg.Copy_contact_success'),
};
